module.exports = __webpack_public_path__ + "static/media/heart.a2f1323e.svg";